import * as types from '../actionType'

const initialState = []

export const summary = (state = initialState, action) => {
    switch (action.type) {
        case types.ORDERS_SUMMARY:
            return action.payload
        default:
            return state
    }
}